<template>
  <div>
    <!-- 原材料  -->
    <div>
      <el-button plain size="small" type="primary" @click="clickImport">导入</el-button>
      <el-button plain size="small" type="danger" @click="clickDel">删除</el-button>
    </div>
    <el-table :data="qutaForm.quta_mtrl_list" border class="vg_mt_16" style="width: 100%" @selection-change="selectChange">
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column align="center" label="序号" type="index"></el-table-column>
      <el-table-column align="center" label="物料编号" min-width="120" prop="mtrl_no">
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_no'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model.trim="qutaForm.quta_mtrl_list[scope.$index].mtrl_no"
              clearable
              disabled
              maxlength="30"
              show-word-limit
              size="small"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料类型" min-width="100" prop="mtrl_type">
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_type'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-select v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_type" disabled size="small">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料名称" min-width="120" prop="mtrl_name">
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_name'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.mtrl_name" class="item" effect="dark" placement="top-start">
              <el-input
                v-model.trim="qutaForm.quta_mtrl_list[scope.$index].mtrl_name"
                clearable
                disabled
                maxlength="30"
                show-word-limit
                size="small"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料规格" min-width="120" prop="mtrl_spec">
        <template slot="header">
          <span style="color: red">物料规格</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_spec'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.mtrl_spec" class="item" effect="dark" placement="top-start">
              <el-input
                v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_spec"
                :autosize="{ minRows: 1, maxRows: 4 }"
                clearable
                maxlength="50"
                show-word-limit
                size="small"
                type="textarea"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="部位" min-width="120" prop="quta_mtrl_part">
        <template slot="header">
          <span style="color: red">部位</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_mtrl_part'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.quta_mtrl_part" class="item" effect="dark" placement="top-start">
              <el-input
                v-model="qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_part"
                :autosize="{ minRows: 1, maxRows: 4 }"
                clearable
                maxlength="50"
                show-word-limit
                size="small"
                type="textarea"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用量" min-width="140" prop="quta_mtrl_consume">
        <template slot="header">
          <span style="color: red">用量</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_mtrl_consume'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume"
              maxlength="15"
              show-word-limit
              size="small"
              @blur="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume = helper.calcPrice(
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume,
                  4,
                  10000000000
                )
              "
              @change="() => getTotalPrice(999)"
              @input="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume =
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="损耗比率" min-width="140" prop="quta_mtrl_lossrate">
        <template slot="header">
          <span style="color: red">损耗比率</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_mtrl_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate"
              maxlength="15"
              show-word-limit
              size="small"
              @blur="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate = helper.calcPrice(
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate,
                  4,
                  10000000000
                )
              "
              @change="() => getTotalPrice(999)"
              @input="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate =
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column align="center" label="含损耗用量" min-width="140" prop="quta_contain_lossrate">
        <template slot="header">
          <span style="color: red">含损耗用量</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_contain_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].quta_contain_lossrate"
              disabled
              maxlength="15"
              show-word-limit
              size="small"
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <!--      <el-table-column label="单价" align="center" prop="mtrl_price" min-width="140">-->
      <!--        <template slot="header">-->
      <!--          <span style="color: red">单价</span>-->
      <!--        </template>-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-form-item-->
      <!--            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_price'"-->
      <!--            label-width="0"-->
      <!--            :rules="{ required: true, message: ' ', trigger: 'blur' }"-->
      <!--          >-->
      <!--            <el-input-->
      <!--              size="small"-->
      <!--              v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_price"-->
      <!--              maxlength="15"-->
      <!--              show-word-limit-->
      <!--              @change="getTotalPrice"-->
      <!--              @input="-->
      <!--                qutaForm.quta_mtrl_list[scope.$index].mtrl_price =-->
      <!--                  qutaForm.quta_mtrl_list[scope.$index].mtrl_price-->
      <!--                    .replace(/^0+(\d)/, '$1')-->
      <!--                    .replace(/^\./, '0.')-->
      <!--                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''-->
      <!--              "-->
      <!--              @blur="-->
      <!--                qutaForm.quta_mtrl_list[scope.$index].mtrl_price = helper.calcPrice(-->
      <!--                  qutaForm.quta_mtrl_list[scope.$index].mtrl_price,-->
      <!--                  4,-->
      <!--                  10000000000-->
      <!--                )-->
      <!--              "-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-form-item>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="总价" align="center" prop="sum_money" min-width="140"></el-table-column>-->
      <el-table-column align="center" label="价格明细" min-width="140">
        <template slot="header">
          <span style="color: red">价格明细</span>
        </template>
        <template slot-scope="scope">
          <template v-if="!expandedPriceDetailRows[scope.$index]">
            <el-button type="text" @click="togglePriceDetail(scope.$index)">展开价格明细</el-button>
          </template>
          <template v-else>
            <el-button type="text" @click="togglePriceDetail(scope.$index)" style="margin-bottom: 8px">收起</el-button>
            <el-form-item label-width="0">
              <el-row>
                <el-col :md="12"><span>复合费用</span></el-col>
                <el-col :md="12">
                  <el-input
                    v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_comp_addcost"
                    maxlength="7"
                    placeholder="暂无复合费用"
                    show-word-limit
                    @change="getTotalPrice"
                    @input="val => (qutaForm.quta_mtrl_list[scope.$index].mtrl_comp_addcost = formatNumberOver100(val))"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label-width="0">
              <el-row>
                <el-col :md="12"><span>印花费用</span></el-col>
                <el-col :md="12">
                  <el-input
                    v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_prit_addcost"
                    maxlength="7"
                    placeholder="暂无印花费用"
                    show-word-limit
                    @change="getTotalPrice"
                    @input="val => (qutaForm.quta_mtrl_list[scope.$index].mtrl_prit_addcost = formatNumberOver100(val))"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item
              v-for="(value, key, index) in qutaForm.quta_mtrl_list[scope.$index].mtrb_bom_mater"
              :key="key + index"
              label-width="0"
            >
              <el-row>
                <el-col :md="12"
                  ><el-tooltip :content="key" effect="dark" placement="top-start">
                    <span style="white-space: nowrap; overflow: hidden; display: block">{{ key }}</span>
                  </el-tooltip></el-col
                >
                <el-col :md="12">
                  <el-input
                    v-model="qutaForm.quta_mtrl_list[scope.$index].mtrb_bom_mater[key]"
                    :placeholder="`暂无${key}费用`"
                    maxlength="7"
                    show-word-limit
                    @change="getTotalPrice"
                    @input="val => (qutaForm.quta_mtrl_list[scope.$index].mtrb_bom_mater[key] = formatNumberOver100(val))"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </template>
      </el-table-column>
      <el-table-column align="right" label="总计" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ calcPriceDetailTotal(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column align="right" label="DYJ报价" min-width="120" prop="dyjsum_money" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-form-item :prop="'quta_mtrl_list.' + scope.$index + '.dyjsum_money'" label-width="0">
            <el-input v-model="qutaForm.quta_mtrl_list[scope.$index].dyjsum_money" disabled size="small"> </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="right" label="采购部报价" min-width="120" prop="purc_price" show-overflow-tooltip></el-table-column>
    </el-table>

    <div class="vd_price_toatl">
      <div class="vd_price">
        <h3><span>总计:</span></h3>
        <h2 class="vg_ml_8" style="color: #c70e0e">
          <span>{{ totalPrice }}</span>
        </h2>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="提示" width="70%">
      <requImport :qutaForm="qutaForm" @childChange="childChange" />
    </el-dialog>
  </div>
</template>

<script>
import requImport from './requImport2.vue';
import { BigNumber } from 'bignumber.js';
import { formatNumberOver100, keep4Decimal } from '@assets/js/regExUtil';

export default {
  name: 'QutaRawMater',
  components: {
    requImport
  },
  props: {
    qutaForm: {
      type: Object,
      required: true,
      default() {
        return {
          quta_mtrl_list: []
        };
      }
    }
  },
  data() {
    return {
      mulTab: [],
      total: 0,
      dialogVisible: false,
      typeList: [
        { value: 0, label: '原面料' },
        { value: 3, label: '加工面料' }
      ],
      totalPrice: 0,
      expandedPriceDetailRows: {}
    };
  },
  created() {
    this.initData();
  },
  computed: {},
  methods: {
    formatNumberOver100,
    keep4Decimal,
    togglePriceDetail(index) {
      this.$set(this.expandedPriceDetailRows, index, !this.expandedPriceDetailRows[index]);
    },
    calcPriceDetailTotal(row) {
      let total = new BigNumber(0)
        .plus(row.mtrl_comp_addcost || 0)
        .plus(row.mtrl_prit_addcost || 0);
      if (row.mtrb_bom_mater) {
        for (const key in row.mtrb_bom_mater) {
          total = total.plus(Number(row.mtrb_bom_mater[key]) || 0);
        }
      }
      return this.helper.haveFour(total.toNumber(), 4);
    },
    initData() {},
    selectChange(selection) {
      this.mulTab = selection;
    },
    clickImport() {
      this.dialogVisible = true;
    },
    clickDel() {
      if (this.mulTab.length === 0) {
        return this.$message.warning('至少选择一条数据');
      }
      let temp = [];
      for (let i = 0; i < this.mulTab.length; i++) {
        let ind = null;
        ind = this.qutaForm.quta_mtrl_list.indexOf(this.mulTab[i]);
        temp.push(ind);
      }
      temp = temp.sort((a, b) => {
        return b - a;
      });
      for (let j of temp) {
        this.qutaForm.quta_mtrl_list.splice(j, 1);
      }
      this.getTotalPrice();
    },
    childChange(selection) {
      selection.forEach(item => {
        item.mtrl_price = this.helper.haveFour(item.mtrl_prod_price, 4);
        let smpl_mtrl_addcost = item.smpl_mtrl_addcost ? item.smpl_mtrl_addcost : 0;
        this.$set(item, 'quta_mtrl_part', ''); //部位
        this.$set(item, 'quta_contain_lossrate', '');
        this.$set(item, 'quta_mtrl_lossrate', item.smpl_mtrl_loss); //损耗百分比
        this.$set(item, 'quta_mtrl_consume', this.helper.haveFour(item.smpl_mtrl_consume, 4)); //用量
        this.$set(item, 'mtrl_addcost', smpl_mtrl_addcost); //额外费用
        this.$set(item, 'mtrl_prit_addcost', item.smpl_prit_addcost); //额外费用
        this.$set(item, 'mtrl_comp_addcost', item.smpl_comp_addcost); //额外费用
        item.mtrb_bom_mater = JSON.parse(item.mtrb_bom_mater || '{}');
        this.qutaForm.quta_mtrl_list.push(item);
      });
      this.dialogVisible = false;
    },
    getTotalPrice(flag) {
      if (flag === 999) {
        this.qutaForm.quta_mtrl_list.forEach(item => {
          item.quta_contain_lossrate = this.helper.haveFour(item.quta_mtrl_lossrate * item.quta_mtrl_consume);
        });
      }
      setTimeout(() => {
        let num = new BigNumber(0);
        if (this.qutaForm.quta_mtrl_list) {
          this.qutaForm.quta_mtrl_list.forEach(item => {
            let num1 = new BigNumber(0)
              .plus(item.mtrl_comp_addcost)
              .plus(item.mtrl_prit_addcost)
              .plus(item.mtrl_price)
              .times(item.quta_contain_lossrate)
              .toNumber();
            // item.dyjsum_money = this.helper.haveFour(num1);
            let temp = new BigNumber(0);
            for (const key in item.mtrb_bom_mater) {
              temp = temp.plus(Number(item.mtrb_bom_mater[key]));
            }
            item.purc_price = this.helper.haveFour(
              temp.plus(item.mtrl_comp_addcost).plus(item.mtrl_prit_addcost).times(item.quta_contain_lossrate).toNumber()
            );
            
            num = num.plus(item.purc_price);
          });
        }
        num = num.toNumber();
        // console.log('目前总金额是，' + num);
        this.$emit('getTotalPriceTo', num);
        this.totalPrice = this.helper.haveFour(num, 4);
      }, 500);
    }
  }
};
</script>

<style scoped>
.vd_price_toatl {
  /* display: flex;
  justify-content: space-between; */
  padding: 10px 20px;
}

.vd_price {
  display: flex;
  justify-content: flex-end;
}
</style>
